import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getGenderService } from './../../Services/genderService'

export const reducerName = 'gender';

const initialState = {
  request: false,
  error: null,
  data: null
};

export const getGender = createAsyncThunk(
  'gender/get',
  async (a, { rejectWithValue }) => {
    try {
      
      const response = await getGenderService();

      return {
        data: response
      };
    } catch (error) {
      return rejectWithValue({
        error: error.message
      })
    }
  }
);


export const genderReducer = createSlice({
  name: reducerName,
  initialState,
  extraReducers: (builder) => {

    builder.addCase(getGender.fulfilled, (state, action) => {
      state.data = action.payload?.data;
      state.request = false;
    })

    builder.addCase(getGender.rejected, (state, action) => {
      state.error = action.payload.error;
      state.request = false;
      state.data = null;
    })

    builder.addCase(getGender.pending, (state) => {
      state.request = true;
      state.error = null;
      state.data = null;
    })
  }
});

export default genderReducer.reducer;
